import { defineRule } from 'vee-validate'

const yyyymmdd = () => {
  defineRule<string, any[]>('yyyymmdd', (value, _target, _ctx: any) => {
    return testYyyymmdd(value)
  })
}

export default yyyymmdd
